import Switch from '@mui/material/Switch';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import { ChangeEvent } from 'react';
import { FormFieldConfig } from '../../Hooks/useForm';
import './biz-switch.scss';

type BizSwitchProps = {
	onChange: (checked: boolean) => void;
	checked: boolean;
	formConfig?: FormFieldConfig;
	disabled?: boolean;
	className?: string;
	label?: string;
	labelPlacement?: FormControlLabelProps['labelPlacement'];
};

export function BizSwitch({ onChange, checked, formConfig, disabled, className, label, labelPlacement }: BizSwitchProps) {
	if (label) {
		return (
			<FormControlLabel
				className='biz-switch-label'
				labelPlacement={labelPlacement}
				label={label}
				control={
					<BizSwitchBase
						checked={checked}
						onChange={onChange}
						disabled={disabled}
						formConfig={formConfig}
						className={className}
					/>
				}
			/>
		);
	}

	return (
		<BizSwitchBase checked={checked} onChange={onChange} disabled={disabled} formConfig={formConfig} className={className} />
	);
}

function BizSwitchBase({ onChange, checked, formConfig, disabled, className }: BizSwitchProps) {
	function changeHandler(e: ChangeEvent<HTMLInputElement>) {
		const newCheckedValue = e.target.checked;
		onChange(newCheckedValue);

		if (formConfig?.state && !formConfig.state.isDirty) {
			formConfig.state.setDirty();
		}
	}

	const cssClasses = `biz-switch ${className}`;

	return (
		<Switch
			className={cssClasses}
			checked={checked}
			onChange={changeHandler}
			disabled={disabled}
			sx={(theme) => ({ '--biz-switch-default-color': theme.palette.primary.main })}
		/>
	);
}
